import React from 'react';
import TextLogin from '../components/Login/TextLogin'




function Login() {
    return (
       
      <div>
        <TextLogin/>
      </div>
    );
}

export default Login;